module.exports = __webpack_public_path__ + "static/media/Avatars_Female-18.859260f4.png";